import React, { Component } from 'react'
import { connect } from 'react-redux'
//import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {attendanceTableReady,rowsPerPageState,searchTextState,paginationState,attendanceIdForAction,previousAttendanceCycleId,previousFilterStartDate,previousFilterEndDate,previousWorkLocationType,previousWorkLocationId,previousFilterCity} from '../redux/attendances'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
//import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/attendanceTable.css'


import {AttendanceCycles,Departments,Cities,EntityType,WorkLocations,Kitchens} from '../../../common/DropDowns/index'

import { EditAttendance } from './ActionButtons'

import { CSVLink,CSVDownload } from 'react-csv'
import { createXLSheetdata,createXLSheetdataSimpliedFormat } from '../services/helpers'


import * as Helpers from '../../../common/helpers'


//import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'



function filterRowDateWise(attendancesData,columnData,editFlagCycle) {
    
    let newArray = []

    if (attendancesData.length > 0) {

            for (var j = 0; j < attendancesData.length; j++) {
                let newEmployeeData=[];
                newEmployeeData.search=true
                newEmployeeData.name=attendancesData[j].employee_name+" - "+attendancesData[j].employee_code
                newEmployeeData.attendances_data=[]
                
                for (let i = 0; i < columnData.length; i++) {

                    let atttendaceFlag=false;
                    let rowData={};
                   
                    for (var k = 0; k < attendancesData[j].attendance_details.length; k++) {

                        if(attendancesData[j].attendance_details[k][columnData[i]]){
                            atttendaceFlag=true;
                            rowData=attendancesData[j].attendance_details[k][columnData[i]]
                            if(editFlagCycle){
                                if(rowData.reason_id && rowData.reason_id>0){
                                    rowData.alreadyEdited=true
                                }else{
                                    rowData.editOption=true
                                    rowData.employee_name=attendancesData[j].employee_name+" - "+attendancesData[j].employee_code
                                    rowData.attendance_date=columnData[i]
                                }
                            }
                        }
                    }

                        if(!atttendaceFlag){
                            rowData.type="-"
                        }

                         newEmployeeData.attendances_data.push(rowData)                   
                }            

            newArray.push(newEmployeeData)
        }
    }
    return newArray
}


function formatExportData(dateRangers,attendancesData) {
    

    let newArray = []

    if (dateRangers.length > 0) {           
            for (var j = 0; j < attendancesData.length; j++) {
                let array={}
                array.name=attendancesData[j]['name']
                    for (var k = 0; k < attendancesData[j]['attendances_data'].length; k++) {
                        if(attendancesData[j]['attendances_data'][k]['type']!=="-"){
                            if(attendancesData[j]['attendances_data'][k]['location_type']==="Kitchen"){
                                array[dateRangers[k+1]]=attendancesData[j]['attendances_data'][k]['type']+" - "+attendancesData[j]['attendances_data'][k]['location_code']
                            }else{
                                array[dateRangers[k+1]]=attendancesData[j]['attendances_data'][k]['type']+" - "+attendancesData[j]['attendances_data'][k]['location_name']
                            }
                        }else{
                             array[dateRangers[k+1]]=attendancesData[j]['attendances_data'][k]['type']
                        }
                        
                    }
                newArray.push(array);
        }

    }

    return newArray;

}




function filterUnwantedData(attendancesData) {
    let array = []
    if (attendancesData && attendancesData.data && attendancesData.data.list) {
        array = attendancesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.employee_id ? lineData.employee_id : ""
            newLineData.employee_name = lineData.employee_name ? lineData.employee_name : ""
            newLineData.employee_code = lineData.employee_code ? lineData.employee_code : ""

            newLineData.attendance_details=lineData.attendance_details && lineData.attendance_details.length>0 ? lineData.attendance_details : []

            newArray[i] = newLineData
        }
    }
    return newArray
}


function filterUnwantedDataSimplfiedFormat(attendancesData) {
    let array = []
    if (attendancesData && attendancesData.data && attendancesData.data.list) {
        array = attendancesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.employee_id = lineData.employee && lineData.employee.code ? lineData.employee.code : ""
            newLineData.employee_name = lineData.employee && lineData.employee.name ? lineData.employee.name : ""
            newLineData.attendance_date = lineData.attendance_date  ? Helpers.getDateFormatForUTC(lineData.attendance_date) : ""
            newLineData.work_location_type = lineData.location_type  ? lineData.location_type : ""


            newLineData.designation = lineData.employee && lineData.employee.designation && lineData.employee.designation.name ? lineData.employee.designation.name : ""

            newLineData.attendance_type = lineData.type  ? lineData.type : ""

            if(lineData.location_type==="Kitchen"){
                 newLineData.work_location=lineData.kitchen_work_location && lineData.kitchen_work_location.name ? lineData.kitchen_work_location.name+" - "+lineData.kitchen_work_location.code : ""
            }else{

                 newLineData.work_location=lineData.office_work_location && lineData.office_work_location.name ? lineData.office_work_location.name : ""
            }

             newLineData.reason_attendance=lineData.reason && lineData.reason.name ? lineData.reason.name : ""
             newLineData.remarks_attendance = lineData.remarks  ? lineData.remarks : ""            


            newArray[i] = newLineData
        }
    }
    return newArray
}





class AttendanceTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            attendanceData: [],
            columnData:[],
            exportSimplifiedFormat:[],
            formattedAttendanceData:[],
            masterFormattedAttendanceData:[],
            attendanceCycleId:"",
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            kitchen_staff:false,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: "",
            workLocationType:"",
            workLocationId:"",
            departmentId:"",            
            filter_cityId:0,
            startDate:"",
            endDate:"",
            CSVDataSimplifiedFormat:"",
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
        this.createCSVDataSimplifiedFormat = this.createCSVDataSimplifiedFormat.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(attendanceTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ATTENDANCE_TABLE))
        this.props.dispatch(subHeaderDataUpdate())



        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        let previousWorkLocationType=""
        let previousWorkLocationId=""
        let filter_cityId=0
        let previousAttendanceCycleId=""
        let previousFilterStartDate=""
        let previousFilterEndDate=""

         if (this.props.attendances && this.props.attendances.previousFilterCity && this.props.attendances.previousFilterCity!==undefined) {
            filter_cityId=this.props.attendances.previousFilterCity
         }


         if (this.props.attendances && this.props.attendances.previousFilterStartDate && this.props.attendances.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.attendances.previousFilterStartDate
         }


         if (this.props.attendances && this.props.attendances.previousFilterEndDate && this.props.attendances.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.attendances.previousFilterEndDate
         }


         if (this.props.attendances && this.props.attendances.previousAttendanceCycleId && this.props.attendances.previousAttendanceCycleId!==undefined) {
            previousAttendanceCycleId=this.props.attendances.previousAttendanceCycleId
         }

         if (this.props.attendances && this.props.attendances.previousWorkLocationType && this.props.attendances.previousWorkLocationType!==undefined) {
            previousWorkLocationType=this.props.attendances.previousWorkLocationType
         }
         if (this.props.attendances && this.props.attendances.previousWorkLocationId && this.props.attendances.previousWorkLocationId!==undefined) {
            previousWorkLocationId=this.props.attendances.previousWorkLocationId
         }

          if(this.props.user.roles[0].includes("Kitchen Manager") || this.props.user.roles[0].includes("Shift Manager") || this.props.user.roles[0].includes("Cluster Manager")){
            this.setState({
                kitchen_staff:true,
                workLocationType:"Kitchen"
            });
            previousWorkLocationType="Kitchen" 
        }


         this.setState({
              workLocationType:previousWorkLocationType,
              workLocationId:previousWorkLocationId,
              filter_cityId:filter_cityId,
              attendanceCycleId:previousAttendanceCycleId,
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            if(this.state.attendanceCycleId && this.state.attendanceCycleId!=="" && this.state.attendanceCycleId!==undefined){
                this.getAttendanceData()
            }else{
                this.getLatestAttendanceCycle()
            }
        });
        
    }

    getLatestAttendanceCycle = () => {
        apiService.getLatestAttendanceCycle()
            .then(attendancesData => {
                if (attendancesData && this.isComponentMounted) {
                    this.validateBuildNumber(attendancesData)
                        if (attendancesData.status === "SUCCESS") {
                                
                                let started=Helpers.getDateFormatForUTC(new Date(attendancesData.data.list[0].started).getTime())
                                let ended=Helpers.getDateFormatForUTC(new Date(attendancesData.data.list[0].ended).getTime())

                            this.props.dispatch(previousAttendanceCycleId(attendancesData.data.list[0].id))
                            this.props.dispatch(previousFilterStartDate(started))
                            this.props.dispatch(previousFilterEndDate(ended))
                            this.setState({
                                attendanceCycleId:attendancesData.data.list[0].id,
                                startDate:started,  
                                endDate:ended
                            },() => {
                                this.getAttendanceData()
                            });
                           
                    }
            }
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(attendanceTableReady(true))                
            })
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 200) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getAttendanceData = () => {
        apiService.getAttendanceData(this.state.attendanceCycleId,this.state.workLocationType,this.state.workLocationId,this.state.filter_cityId)
            .then(attendancesData => {
                if (attendancesData && this.isComponentMounted) {
                    this.validateBuildNumber(attendancesData)
                    if (attendancesData.status === "SUCCESS") {
                        let array = filterUnwantedData(attendancesData), pageNo = 1
                        if (this.props.attendances && this.props.attendances.previousPaginationValue) {
                            pageNo = this.props.attendances.previousPaginationValue
                        }


                        let dateRangers=Helpers.getDateRangeBetweenDates(this.state.startDate,this.state.endDate);

                        let rowWiseAttenaceData=[];

                        // let startDate=this.state.startDate;
                        // if(new Date().getDate()>=1 && new Date().getDate()<=21){

                        //         if (new Date(startDate+" 00:00")>=new Date((new Date().getMonth()===0 ? (new Date().getFullYear()-1)+"-12" : new Date().getFullYear()+"-"+new Date().getMonth())+"-21 00:00")){
                        //             rowWiseAttenaceData=filterRowDateWise(array,dateRangers,true);

                        //         }else{
                        //             rowWiseAttenaceData=filterRowDateWise(array,dateRangers,false);

                        //         }
                        // }else{
                        //      if(new Date(startDate+" 00:00")>=new Date((new Date().getMonth()===12 ? (new Date().getFullYear()+1)+"-01" : new Date().getFullYear()+"-"+new Date().getMonth()+1)+"-21 00:00")){

                        //             rowWiseAttenaceData=filterRowDateWise(array,dateRangers,true);
                        //      }else{

                        //             rowWiseAttenaceData=filterRowDateWise(array,dateRangers,false);
                        //      }
                        //}

                        if(Helpers.isItCurrentAttendanceCyle(this.state.startDate)){

                              rowWiseAttenaceData=filterRowDateWise(array,dateRangers,true);
                        }else{

                              rowWiseAttenaceData=filterRowDateWise(array,dateRangers,false);
                        }


                      


                        dateRangers=["Name"].concat(dateRangers)                        


                        this.createCSVData(formatExportData(dateRangers,rowWiseAttenaceData))



                         this.setState({
                            attendanceData: array,
                            page: pageNo,
                            columnData:dateRangers,
                            formattedAttendanceData:rowWiseAttenaceData,
                            masterFormattedAttendanceData:rowWiseAttenaceData
                        })




                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: attendancesData.reason ? attendancesData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(attendanceTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(attendanceTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

      searhAttendanceInputChange = (e) => {
        let searachValue=e.target.value.toLowerCase();

        let attendancesDetails=this.state.masterFormattedAttendanceData;

        if((attendancesDetails!=="" && attendancesDetails!==undefined) || (searachValue!==""  && searachValue!==undefined) ){
            attendancesDetails.map(function(item, index) {
                item.search=false
                if(item.name.toLowerCase().indexOf(searachValue)>-1){
                    item.search = true
                    return true
                }

                // if(item.attendances_data!=="" && item.attendances_data!==undefined){
                //     item.attendances_data.map(function(item2, index2) {
                //         if(item2.type!=="-"){
                //             if(item2.type.toLowerCase().indexOf(searachValue)>-1){
                //                      item.search = true
                //                      return true
                //                 }
                //             }
                        
                //     }) 
                // }               
                
                 return true
            })
        }

        this.setState({
            formattedAttendanceData: attendancesDetails
        });

    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }


   workLocationTypeChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationType(""))
             this.setState({
                workLocationType:"",
                workLocationId:"",
                departmentId:""
            },() => {
                this.props.dispatch(previousWorkLocationId(""))
                this.props.dispatch(previousWorkLocationType(""))
                this.getAttendanceData();
            });
        }else{
            this.props.dispatch(previousWorkLocationType(data.value))
            this.setState({
                workLocationType:data.value
            })
        }
    }

    workLocationChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationId(""))
             this.setState({
                workLocationId:""
            })
        }else{
            this.props.dispatch(previousWorkLocationId(data.value))
            this.setState({
                workLocationId:data.value
            })
        }
    }


    kitchenChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationId(""))
             this.setState({
                workLocationId:""
            })
        }else{
            this.props.dispatch(previousWorkLocationId(data.value))
            this.setState({
                workLocationId:data.value
            })
        }
    }

       cityChange = (data) => {
        

        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
             this.setState({
                filter_cityId:"",
                workLocationType:"",
                workLocationId:"",
                departmentId:""
            },() => {
                this.props.dispatch(previousFilterCity(""))
                this.props.dispatch(previousWorkLocationId(""))
                this.props.dispatch(previousWorkLocationType(""))
                this.getAttendanceData();
            });

        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
                filter_cityId:data.value
            })
        }
    }

     attendanceCyclesChange = (data) => {
        

        if(data.value==="" || data.value===undefined){
             this.setState({
                attendanceCycleId:"",
                startDate:"",
                endDate:"",
                previousFilterStartDate:"",
                previousFilterEndDate:"",
            },() => {
                this.props.dispatch(previousAttendanceCycleId(""))
            });

        }else{
            this.props.dispatch(previousAttendanceCycleId(data.value))
            this.setState({
                attendanceCycleId:data.value,
                startDate:Helpers.getDateFormatForUTC(new Date(data.label.split("to")[0].trim()).getTime()),
                endDate:Helpers.getDateFormatForUTC(new Date(data.label.split("to")[1].trim()).getTime()),
                previousFilterStartDate:Helpers.getDateFormatForUTC(new Date(data.label.split("to")[0].trim()).getTime()),
                previousFilterEndDate:Helpers.getDateFormatForUTC(new Date(data.label.split("to")[1].trim()).getTime())
            })

        }
    }


    



    departmentChange = (data) => {

         this.setState({
                    departmentId:data.value,
                });       
        

        }
       
    

    


    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.attendances && this.props.attendances.previousRowsPerPageValue) {
            value = this.props.attendances.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {

        

        let attendancesExport = "attendances_export_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

        let attendancesExportSimplifiedFormat = "attendances_simplified_export_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

            


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>




                {(() => {
                if(this.state.kitchen_staff){
                        return (    




                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">
            

                     <div className="col-md-3 col-sm-12 col-xs-12 div-margins" style={{textAlign:"center"}}>
                                 <AttendanceCycles attendanceCyclesChange={this.attendanceCyclesChange} selectedValue={this.state.attendanceCycleId} />
                            </div>

                            <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <Kitchens kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                            </div>



                   
                   
                </div> 

                            )
                    }else{
                        return(



                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">

                     
                     <div className="col-md-3 col-sm-12 col-xs-12 div-margins" style={{textAlign:"center"}}>
                                 <AttendanceCycles attendanceCyclesChange={this.attendanceCyclesChange} selectedValue={this.state.attendanceCycleId} />
                            </div>


                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_cityId} />
                    </div>

                     {(() => {
                         if(this.state.filter_cityId && this.state.filter_cityId!=="" && this.state.filter_cityId!==undefined){
                         return (

                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">

                    <EntityType entityTypeChange={this.workLocationTypeChange} selectedValue={this.state.workLocationType} type="WORK_LOCATIONS" />

                    </div>

                        )
                    }
                })()}

                      {(() => {
                         if(this.state.workLocationType!=="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                            <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <WorkLocations type={this.state.workLocationType} city_id={this.state.filter_cityId} workLocationChange={this.workLocationChange} selectedValue={this.state.workLocationId} />
                            </div>
                          )
                         }
                         if(this.state.workLocationType==="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                             <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <Kitchens selectedCity={this.state.filter_cityId} kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                            </div>
                         )
                         }
                         })()}

                          {(() => {
                         if(this.state.workLocationType!=="Kitchen" && this.state.workLocationId && this.state.workLocationId!=="" && this.state.workLocationId!==undefined){
                         return (

                             <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                    <Departments departmentChange={this.departmentChange} selectedValue={this.state.departmentId} />

                              </div>

                               )
                         }
                         })()}


                   
                </div> 

                  )
                    }
                })()}

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins" style={{marginBottom:"5px"}}>
            
                    <div className="col-md-5 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredAttendanceList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>



                         {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/attendances/exportAccess",this.props.user)){
                        return(


                            <CSVLink
                                    data={this.CSVData}
                                    className="btn btn-primary button-custom"
                                    style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                                    filename={attendancesExport}>
                                    Export
                                </CSVLink>
                            )
                        }
                    })()}

                      {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/attendances/exportAccess",this.props.user)){
                        return(

                            <Button style={{ "background":"#3f51b5",color:"white","borderColor":"#3f51b5","marginLeft":"5px" }} onClick={this.createCSVDataSimplifiedFormat}>Export in Simplfied Format</Button>    

                                
                            )
                        }
                    })()}

                      {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/attendances/exportAccess",this.props.user)){
                        return(

                            
                            <CSVLink
                                    data={this.state.CSVDataSimplifiedFormat}
                                    id="exportCsvButton"
                                    className="btn btn-primary button-custom"
                                    style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc",display:"none"}}
                                    filename={attendancesExportSimplifiedFormat}>
                                    Export
                                </CSVLink>      

                                
                            )
                        }
                    })()}



                    </div>

                      <div className="col-md-7 col-sm-12 col-xs-12 div-margins">
                    {(() => {
                        if(Helpers.checkPrivileges("/dashboard/attendances/addEdit",this.props.user)){
                            return (

                         

                           <div className="col-md-9">
                             <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px",float: "right",background: "teal",borderColor: "teal"}}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(attendanceIdForAction())
                                        this.props.history.push("/dashboard/attendances/addEdit")
                                    }}>
                                   <i class="fa fa-clock-o"></i> Mark Attendance
                                </button>
                               

                                   </div>    

                              )
                                }
                    })()}

                                    <div className="col-md-3" style={{"float":"right"}}>
                                                            <input placeholder="Search Employee" id="searchSkuId"  className="form-control" type="text"
                                                            onChange={(e) => {
                                                            e.preventDefault();
                                                            this.searhAttendanceInputChange(e)
                                                            }}
                                                            />
                                                        </div>
                            </div>


                    </div>


                     

                    


            </div>
        )
    }


    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                     
                    {/*
                     {props.components.sizePerPageDropdown}
                    */}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    
                    {(() => {
                        if(this.state.attendanceData.length>0){
                            return (
                            <p>
                                 Showing {this.state.attendanceData.length} results
                            </p>
                            )
                        }
                    })()}

                     {/*
                    {(() => {
                        if(this.state.attendanceData.length>=(this.props.attendances.previousPaginationValue*this.props.attendances.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.attendances.previousPaginationValue*this.props.attendances.previousRowsPerPageValue)-this.props.attendances.previousRowsPerPageValue+1} to {this.props.attendances.previousPaginationValue*this.props.attendances.previousRowsPerPageValue} of {this.state.attendanceData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.attendances.previousPaginationValue*this.props.attendances.previousRowsPerPageValue)-this.props.attendances.previousRowsPerPageValue+1} to {this.state.attendanceData.length} of {this.state.attendanceData.length} results
                            </p>
                            )
                        }
                    })()}
                    */}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                    {/*
                     {props.components.pageList}
                    */}
                </div>
            </div> 
        )   
    }

    getAttendanceTableRows = (row,date) => {

        return (<td>"NA"</td>)
    }

    getFilteredAttendanceList = () => {
       
        this.props.dispatch(attendanceTableReady(false))
        //this.resetSearchAndPagination()
        this.getAttendanceData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
   


    resetFilterValues = () => {
        

        this.props.dispatch(attendanceTableReady(false))
        this.setState({
            filter_cityId:0,
            workLocationType:"",
            workLocationId:"",
            attendanceCycleId:""
        },() => {
            document.getElementById("searchSkuId").value=""
            this.props.dispatch(previousAttendanceCycleId(""))
            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousWorkLocationId(""))
            this.props.dispatch(previousWorkLocationType(""))

            this.getLatestAttendanceCycle();
        });

        
    }



     createCSVData(csvData) {
        let attendanceList = []
        if (csvData) {
            attendanceList = JSON.parse(JSON.stringify(csvData))
            attendanceList = createXLSheetdata(attendanceList)
        }
        this.CSVData = attendanceList
    }

     createCSVDataSimplifiedFormat() {

        this.props.dispatch(attendanceTableReady(false))  

        apiService.getAttendanceDataSimplifiedFormnat(this.state.attendanceCycleId,this.state.workLocationType,this.state.workLocationId,this.state.filter_cityId)
            .then(attendancesData => {
                if (attendancesData && this.isComponentMounted) {
                    this.validateBuildNumber(attendancesData)
                        if (attendancesData.status === "SUCCESS") {
                                
                             let array = filterUnwantedDataSimplfiedFormat(attendancesData)

                              let attendanceList = []
                              if (array) {
                                    attendanceList = JSON.parse(JSON.stringify(array))
                                    attendanceList = createXLSheetdataSimpliedFormat(attendanceList)
                                }
                                
                                this.setState({
                                    CSVDataSimplifiedFormat: attendanceList
                                },() => {
                                    document.getElementById("exportCsvButton").click()
                                    this.props.dispatch(attendanceTableReady(true))
                                });

                             

                    }
            }
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(attendanceTableReady(true))                
            })
        
        return false
    }







   

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }


    resetPagination = () => {
        if (this.props.attendances && this.props.attendances.previousPaginationValue
            && this.props.attendances.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }



    render() {
        // let sizeperPage = 15

        // if (this.props.attendances && this.props.attendances.previousRowsPerPageValue) {
        //     sizeperPage = this.props.attendances.previousRowsPerPageValue
        // }

        // const options = {
        //     page: this.state.page,  // which page you want to show as default
        //     sizePerPage: sizeperPage,  // which size per page you want to locate as default
        //     pageStartIndex: 1, // where to start counting the pages
        //     paginationSize: 3,  // the pagination bar size.
        //     prePage: 'Prev', // Previous page button text
        //     nextPage: 'Next', // Next page button text
        //     firstPage: 'First', // First page button text
        //     lastPage: 'Last', // Last page button text
        //     paginationPosition: 'bottom',  // default is bottom, top and both is all available
        //     sizePerPageListPosition: 'bottom',
        //     sizePerPageDropDown: this.rowsperPageDropdown,
        //     searchPanel: (props) => (<SearchField { ...props }
        //         callback={this.resetPagination}
        //         ref={el => this.searchBox = el} />),
        //     toolBar: this.createCustomToolBar,
        //     paginationPanel: this.createCustomFooter,
        //     onlyOneExpanding: true,
        //     expandRowBgColor: '#e1e5ed',
        //     expandBy: 'column',  //Available value is row and column, default is row.
        //     onPageChange: this.onPageChange,
        // }


        return (


        <div className="react-bs-table-container attendance-table-container">
   {this.createCustomToolBar()}
   <div className="attendance-table" style={{ marginBottom: '0px',background: "white" , height: this.state.tableHeight,overflow: "auto" }}>
                <Dialog ref={el => this.dialog = el} />
                <table className="table table-bordered table-hover">
                    <thead>
                          {(() => {

                            if(this.state.columnData && this.state.columnData.length>0){
                                    return(
                                        <tr>
                                    {this.state.columnData.map((item) => (
                                            <th>

                                             {(() => {
                                            if(item==="Name"){
                                                return(
                                                    <span>Name</span>
                                                    )
                                            }else{
                                                    return(
                                                        <span>{Helpers.getDisplayDateFormateMonthDate(item)}</span>
                                                        )
                                                }
                                            })()}

                                            </th>
                                            
                                    ))}
                                    </tr>

                                    )
                                }

                            })()} 
                    </thead>

                  
                        {(() => {


                            if(this.state.formattedAttendanceData && this.state.formattedAttendanceData.length>0){
                                   return(
                                        
                                        <tbody>

                                             
                                                {this.state.formattedAttendanceData.map((item) => (

                                                        item.search ? (

                                                    <tr>
                                                    <td>{item.name}</td>
                                                    
                                                        {item.attendances_data.map((item2,index) => (
                                                            <td>
                                                    {(() => {
                                                        if(item2.location_type==="Kitchen"){
                                                            return(
                                                                    

                                                                    <p> 

                                                                       {(() => {
                                                                                    if(item2.type==="-"){
                                                                                        return(

                                                                      <span>-</span>
                                                                      )
                                                                  }else { 
                                                                    return (

                                                                          <span  className={"attendance-type-class attendance-type-"+item2.type.replaceAll(" ","_")+""}>{item2.type}</span>
                                                                    )
                                                                }

                                                                })()}

                                                                        {(() => {
                                                                                    if(item2.location_code){
                                                                                        return(
                                                                                        
                                                                               <span>{item2.location_code}</span>
                                                                                        )
                                                                                    }
                                                                                
                                                                            })()}
                                                                         {(() => {
                                                                                    if(item2.editOption && Helpers.checkPrivileges("/dashboard/attendances/update",this.props.user)){
                                                                                        return(
                                                                                        <EditAttendance data={item2}/>
                                                                                        )
                                                                                    }
                                                                                })()}
                                                                         {(() => {
                                                                                    if(item2.alreadyEdited && Helpers.checkPrivileges("/dashboard/attendances/update",this.props.user)){
                                                                                        return(
                                                                                        <span className="reason-class" title={item2.reason+" - "+ item2.remarks}><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Edited</span>
                                                                                        )
                                                                                    }
                                                                                })()}





                                                                    </p>   
                                                                )
                                                            }else{
                                                                    return(
                                                                            <p>
                                                                               {(() => {
                                                                                    if(item2.type==="-"){
                                                                                        return(

                                                                      <span>-</span>
                                                                      )
                                                                  }else { 
                                                                    return (

                                                                          <span  className={"attendance-type-class attendance-type-"+item2.type.replaceAll(" ","_")+""}>{item2.type}</span>
                                                                    )
                                                                }

                                                                })()}

                                                                            {(() => {
                                                                                    if(item2.location_name){
                                                                                        return(

                                                                               <span>{item2.location_name}</span>
                                                                                        )
                                                                                    }
                                                                                
                                                                            })()}
                                                                               {(() => {
                                                                                    if(item2.editOption && Helpers.checkPrivileges("/dashboard/attendances/update",this.props.user)){
                                                                                        return( <EditAttendance data={item2}/>
                                                                                        )
                                                                                    }
                                                                                })()}
                                                                         {(() => {
                                                                                    if(item2.alreadyEdited && Helpers.checkPrivileges("/dashboard/attendances/update",this.props.user)){
                                                                                        return(
                                                                                        <span className="reason-class" title={item2.reason+" - "+ item2.remarks}><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Edited</span>
                                                                                        )
                                                                                    }
                                                                                })()}
                                                                            </p>    
                                                                        
                                                                    )
                                                            }
                                                        })()} 
                                                                        
                                                            </td>
                                                       ))}

                                                    </tr>
                                                             
                                                             ) : null                         
                                                ))}

                                     </tbody>

                                    )
                                }


                        })()} 



                </table>
            </div>
            {this.createCustomFooter()}
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        attendances: state.attendances
    }
}

export default connect(mapStateToProps)(withRouter(AttendanceTable))


// WEBPACK FOOTER //
// ./src/modules/Attendance/Components/AttendanceTable.js